/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Home_Ogtitle1Inputs */

const en_seo_home_ogtitle1 = /** @type {(inputs: Seo_Home_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI – Best AI Tools for Every Task`)
};

const zh_seo_home_ogtitle1 = /** @type {(inputs: Seo_Home_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 工具导航 – 每个任务最好的 AI 工具`)
};

/**
* | output |
* | --- |
* | "Seek AI – Best AI Tools for Every Task" |
*
* @param {Seo_Home_Ogtitle1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_home_ogtitle1 = /** @type {((inputs?: Seo_Home_Ogtitle1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Home_Ogtitle1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_home_ogtitle1(inputs)
	return zh_seo_home_ogtitle1(inputs)
});
export { seo_home_ogtitle1 as "seo.home.ogTitle" }